export interface ShouldBlockEventGuestParams {
    /** The member holds a live ticket on this event but owns no primary submission for it. */
    isEventGuest: boolean;
    /** The member has resolved the existing-submission gate (e.g. switched application type). */
    suppressExistingSubmissionGate: boolean;
    /** A submit has been fired this session. */
    hasSubmitted: boolean;
    /** A submit has succeeded this session. */
    isSubmitSuccess: boolean;
}

/**
 * Whether an invited event guest must be blocked from primary registration.
 *
 * Mirrors the existing-submission gate's post-submit suppression (BC-4439) so a late
 * event-guest lookup cannot resurface the block after a legitimate submit, and so the
 * realign race fixes are respected.
 */
export function shouldBlockEventGuest({
    isEventGuest,
    suppressExistingSubmissionGate,
    hasSubmitted,
    isSubmitSuccess,
}: ShouldBlockEventGuestParams): boolean {
    return (
        isEventGuest &&
        !suppressExistingSubmissionGate &&
        !hasSubmitted &&
        !isSubmitSuccess
    );
}
